export const compareCurrentHour = (hour: number): boolean => new Date().getHours() === hour;
